var ProxyUrl = "https://" +  window.location.host + "/" + document.querySelector(['script[data-id="proxy-url"]']).getAttribute('data-proxy-url')

var token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0V2ZoM3ljdTJTRW5LYURvVkNLY0FyTlMiLCJpc3MiOiJhcGkuZm9ybWJ1Y2tldC5jb20iLCJ1aWQiOiI1YjMyMzc5ODg0OTNhODZjZTgxYWE1MDIiLCJleHAiOjE1MzI2MDk2ODgsImlhdCI6MTUzMDAxNzY4OH0.G7gCbqRZ4-sSKEpN1EEOIux3GnNYiaKq140zZzxsiC0'

$(document).ready(function() {
  var $form = $('#contact_form')
  var $alert = $('#contact-form-alert')
  var $stores = $('#field-contact-store')
  var stores = $.get(ProxyUrl + '/store_locations')
  var _store_email = $stores.find(':selected').data('email')
  var url = 'https://api.formbucket.com/f/' + $form.data('bucket')

  stores.done(function (response) {
    var html = ''
    var locations = response.locations

    for (var i = 0; i < locations.length; i++) {
      var name = locations[i].location_name
      var email = locations[i].store_email
      html += '<option data-email="'+ email +'" value="'+ name +'">' + name + '</option>'
    }

    html += '<option data-email="commisary@gigiscorp.com" value="Store Not Listed">Store Not Listed</option>'

    $stores.append(html)
  })

  $stores.on('change', function () {
    var $this = $(this)
    var $selected = $this.find(':selected')
    _store_email = $selected.data('email')
  })

  $form.on('submit', function (event) {
    event.preventDefault()
    var $inputs = $('[name^=contact]', $form)
    var $submit = $('.form-btn', $form)

    $submit.attr('disabled', 'disabled')
    $alert.removeClass('error success').text('')

    var data = {
      // __platform: navigator.platform,
      // __browser: navigator.userAgent,
      _store_email: _store_email,
      _submitted_date: new Date().toLocaleString("en-US", {
        timeZone: "America/Chicago",
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }) + ' CT'
    }

    var re = /\[(.*)\]/i

    $inputs.each(function () {
      var $t = $(this)
      var value = $t.val()
      var name = $t.attr('name')
      var key = name.match(re)[1].replace('-', '_')
      data[key] = value
    })

    var valid = validate($form)

    if (valid) {
      var response = submit(data)
      $alert.removeClass('error success').text('Submitting Form')

      response.done(function(response) {
        if (response.id) {
          $alert.addClass('error').text('Thank you!')
          $submit.remove()

          setTimeout(function () {
            $('#popup-contact').removeClass('expanded')
          }, 3500);
        }
      })
    } else {
      $alert.addClass('error').text('Please input required fields')
      $submit.removeAttr('disabled')
    }
  })


  function validate ($form) {
    var $inputs = $('.rqrd', $form)

    $inputs.each(function () {
      var $this = $(this)
      var value = $this.val()

      if (value === false || value === '') {
        $this.addClass('has-error')
      } else {
        $this.removeClass('has-error')
      }
    })

    return $('.has-error', $form).length === 0
  }

  function submit (data) {
    return $.ajax({
      type: 'POST',
      url: url,
      headers: {
        'accept' : 'application/javascript',
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data),
      crossDomain:true
    })
  }
})
